import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RealtorOfferStoreType } from './models';

const initialState: RealtorOfferStoreType = {
  view: {
    visible: false,
    status: 'ACCESSED',
    house: {
      id: null,
      name: null
    }
  },
  offerTerms: {
    visible: false
  },
  rejected: {
    visible: false
  }
};

const realtorOfferSlice = createSlice({
  initialState,
  name: 'realtor-offer-slice',
  reducers: {
    // VIEW
    setView: (state, actions: PayloadAction<RealtorOfferStoreType['view']>) => {
      state.view = actions.payload;
    },
    setViewPage: (state, actions: PayloadAction<number>) => {
      state.view.page = actions.payload;
    },
    setHouse: (state, action: PayloadAction<RealtorOfferStoreType['view']['house']>) => {
      state.view.house = action.payload;
    },

    // OFFER TERMS
    setOfferTerms: (state, actions: PayloadAction<RealtorOfferStoreType['offerTerms']>) => {
      state.offerTerms = actions.payload;
    },

    // REJECTED
    setRejected: (state, actions: PayloadAction<RealtorOfferStoreType['rejected']>) => {
      state.rejected = actions.payload;
    }
  }
});

export const realtorOfferReducer = realtorOfferSlice.reducer;
export const { setView, setHouse, setViewPage, setOfferTerms, setRejected } = realtorOfferSlice.actions;
